import clsx from 'clsx';
import { useMeasure } from 'react-use';
import React, { Children, useMemo, isValidElement, cloneElement } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Layout = _ref => {
  let {
    className = '',
    hasTableOfContents = false,
    children
  } = _ref;
  // Responsive queries
  const [gridEl, {
    width: gridWidth
  }] = useMeasure();
  const childrenWithProps = Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a
    // typescript error too.
    if ( /*#__PURE__*/isValidElement(child)) {
      //@ts-ignore
      return /*#__PURE__*/cloneElement(child, {
        gridWidth
      });
    }

    return child;
  });
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.container, className),
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles.grid, hasTableOfContents ? styles['-hasTableOfContents'] : '') // @ts-ignore
      ,
      ref: gridEl,
      children: childrenWithProps
    })
  });
};
export const MainLayout = _ref2 => {
  let {
    children,
    isFullWidth = false,
    className = ''
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.grid__main, isFullWidth ? styles['-fullWidth'] : '', className),
    children: children
  });
};
export const SidebarLayout = _ref3 => {
  let {
    children,
    gridWidth = 0,
    hasTopPadding = false,
    isMobileCollapsed = false,
    className = ''
  } = _ref3;
  // Determine if sidebar should be removed
  // completedly from mobile users
  const isRevealed = useMemo(() => {
    if (!isMobileCollapsed) return true;
    return gridWidth >= 688;
  }, [isMobileCollapsed, gridWidth]);
  return isRevealed ? /*#__PURE__*/_jsx("aside", {
    className: clsx(styles.grid__sidebar, hasTopPadding ? styles['grid__sidebar--topPadding'] : '', className),
    children: children
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};
export const TableOfContentsLayout = _ref4 => {
  let {
    children,
    gridWidth = 0,
    hasTopPadding = false,
    className = ''
  } = _ref4;
  // Hide Table of Contents bar from non-desktop users
  const isRevealed = useMemo(() => gridWidth >= 1184, [gridWidth]);
  return isRevealed ? /*#__PURE__*/_jsx("aside", {
    className: clsx(styles.grid__tableOfContents, hasTopPadding ? styles['grid__tableOfContents--topPadding'] : '', className),
    children: children
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};
export const SectionLayout = _ref5 => {
  let {
    children,
    hasTopPadding = false,
    className = ''
  } = _ref5;
  return /*#__PURE__*/_jsx("section", {
    className: clsx(styles.section, hasTopPadding ? styles['section--topPadding'] : '', className),
    children: children
  });
};